import { LOAD_NEWS, LOAD_NEW_CATEGORY } from '../../constants/ActionTypes';
import { fetchApi } from "../../utils/api";

export async function getBLogs(payload, dispatch) {
    try {
        let response = await fetchApi(`/app/blog/get-list-blog`, "get", payload);

        if (response.code !== 200) {
            return {
                rows: [],
            };
        }

        if (payload.page === 1) {
            dispatch(saveNews(response.data.rows));
        }

        return response.data;
    } catch (error) {
        console.log(error);
        return {
            rows: [],
        };
    }
}
export function saveNews(payload) {
    return {
        type: LOAD_NEWS,
        payload
    };
}

export async function getAllCategory(payload, dispatch) {
    try {
        let response = await fetchApi(`/app/blog/get-all-blog-category`, "get", payload);

        if (response.code === 200) {
            dispatch(saveCategory(response.data?.rows));
        }

        return response;
    } catch (error) {
        return {
            "signal": 0,
            "message": "ERROR",
            "code": 400
        };
    }
}

export function saveCategory(payload) {
    return {
        type: LOAD_NEW_CATEGORY,
        payload
    };
}

export async function getListPostHot(payload) {
    try {
        let response = await fetchApi(`/app/blog/get-news-hot`, 'get', payload);

        if (response.code !== 200) {
            return {
                data: {},
            };
        }
        return response.data;
    } catch (error) {
        console.log(error);
        return {
            rows: [],
        };
    }
}

export async function getListPostNew(payload) {
    try {
        let response = await fetchApi(`/app/blog/get-blog-new`, 'get', payload);

        if (response.code !== 200) {
            return {
                data: {},
            };
        }
        return response.data;
    } catch (error) {
        console.log(error);
        return {
            rows: [],
        };
    }
}